"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    text: zod_1.z.string((0, validation_1.labelZodErrors)("Text")).optional(),
});
const dataSchema = zod_1.z.object({
    text: zod_1.z.string((0, validation_1.labelZodErrors)("Text")).min(1, "Text is required."),
});
exports.default = new ItemDefinition_1.ItemDefinition("MultiLineText", configSchema, dataSchema, new validation_1.ValidatorPipeline("MultiLineText Config Validator", []), new validation_1.ValidatorPipeline("MultiLineText Data MultiLineText", []));
//# sourceMappingURL=MultiLineText.js.map